<template>
<main-content>
    <kt-panel>
        <kt-panel-header >
            <kt-panel-header-toolbar >
                <ul class="nav nav-pills" role="tablist">
                    <li class="nav-item">
                        <a :class="['nav-link', currentTab === 1 ? 'active' : '']" href="#gateway-form" @click="gotoTab(1)">
                            {{ $t('label.gateway_form') }}
                        </a>
                    </li>
                    <li class="nav-item">
                        <a :class="['nav-link', currentTab === 2 ? 'active' : '']" href="#changes-requests" @click="gotoTab(2)">
                            {{ $t('label.changes_requests') }}
                        </a>
                    </li>
                    <li class="nav-item">
                        <a :class="['nav-link', currentTab === 3 ? 'active' : '']" href="#wallet-settings" @click="gotoTab(3)">
                            {{ $t('label.wallet_settings') }}
                        </a>
                    </li>
                </ul>
            </kt-panel-header-toolbar>
        </kt-panel-header>
        <div class="tab-content">
            <div :class="['tab-pane', currentTab === 1 ? 'active' : '']">
                <gateway-form v-if="status !== 'loading'" :form_data="form_data" :submit="submit"></gateway-form>
            </div>
            <div :class="['tab-pane', currentTab === 2 ? 'active' : '']">
                <change-requests v-if="status == 'setFormData'" :form_data="form_data"></change-requests>
            </div>
            <div :class="['tab-pane', currentTab === 3 ? 'active' : '']">
                <wallet-settings></wallet-settings>
            </div>
        </div>
    </kt-panel>
</main-content>
</template>

<script>
import mainContent from '@/components/main-content'
import changeRequests from './components/change-requests'
import GatewayForm from './components/update-form'
import WalletSettings from './components/wallet-settings'
import $ from 'jquery'
import { KTApp } from '@/plugins/core/app'
import { gatewayService } from '@/common/api.service'
import { mapGetters } from 'vuex'

export default {
    components: {
        mainContent,
        GatewayForm,
        WalletSettings,
        'change-requests': changeRequests
    },
    computed: {
        ...mapGetters('gateway', [
            'form_data', 'status'
        ])
    },
    data() {
        return {
            currentTab: 1,
            'hashid': this.$route.params.hashid,
        }
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
            vm.$store.dispatch('gateway/find', vm.hashid)
        })
    },
    mounted() {
        if (window.localStorage.getItem('secondPreviousRoutePath') === this.$router.history.current.path) {
            let tab = window.localStorage.getItem('gateway_update_active_tab');
            this.currentTab = (tab != null && tab != undefined) ? parseInt(tab) : 1;
        }
    },
    methods: {
        gotoTab(selectedTab) {
            this.currentTab = selectedTab;
            window.localStorage.setItem('gateway_update_active_tab', selectedTab);
        },
        submit(e) {
            let form = $('#gateway_form')
            let btn = $('#submit_btn')

            if (this.form_data.status == 10) {
                form.validate({
                    rules: {
                        merchant_type: {
                            required: true,
                        },
                        com_name_fa: {
                            required: function(){
                                return $("#merchant_type").val() == 1;
                            }
                        },
                        com_name_en: {
                            required: function(){
                                return $("#merchant_type").val() == 1;
                            }
                        },
                        national_legal_code: {
                            required: function(){
                                return $("#merchant_type").val() == 1;
                            }
                        },
                        register_number: {
                            required: function(){
                                return $("#merchant_type").val() == 1;
                            }
                        },
                        register_date: {
                            required: function(){
                                return $("#merchant_type").val() == 1;
                            }
                        },
                        farsi_name: {
                            required: true,
                        },
                        english_name: {
                            required: true,
                        },
                        subcategory_code: {
                            required: true,
                        },
                        address: {
                            required: true,
                        },
                        telephone: {
                            required: true
                        },
                        logo: {
                            required: true
                        },
                        sheba_number: {
                            required: true
                        },
                        merchant_share_percent: {
                            required: true
                        },
                        site_address: {
                            required: true,
                            url: true
                        },
                        abroad_ips_only_by_user: {
                            required: true
                        },
                        tax_payer_code: {
                            required: function(){
                                return $("#merchant_type").val() == 1;
                            },
                            digits:10
                        },
                    }
                })
            } else {
                form.validate({
                    rules: {
                        merchant_share_percent: {
                            required: true
                        }
                    }
                })
            }

            if(!form.valid()) {
                return
            }

            KTApp.progress(btn)

            let params = this.$store.getters['gateway/form_data']
            // let form_data = new FormData
            gatewayService.update(this.hashid, params).then(response => {
                this.$store.commit('gateway/clearFormData')
                this.$router.push('/gateways')
            })
            .catch(({response}) => {
                if(response.data) {
                    form.validate().showErrors(response.data.data)
                }
                this.showMsg(form, 'danger', response.data.message)
            })
            .finally(() => {
                KTApp.unprogress(btn)
            })
        },
    },
}
</script>

<style>
    .dropdown.bootstrap-select.disabled {
        border: 1px solid #e2e5ec;
        border-radius: 4px;
        background-color: #f7f8fa;
        opacity: 1;
        color: #495057;
    }
</style>